<template>
  <div class="azcon-catalog-skeleton">
    <div class="azcon-catalog-skeleton__tabs">
      <div class="azcon-catalog-skeleton__tab azcon-catalog-skeleton__tab--active"></div>
      <div class="azcon-catalog-skeleton__tab"></div>
    </div>
    <div class="azcon-catalog-skeleton__chips">
      <div v-for="idx in 4" :key="idx" class="azcon-catalog-skeleton__chip"></div>
    </div>
    <div class="azcon-catalog-skeleton__grid">
      <azcon-training-card-skeleton v-for="idx in 6" :key="'card_' + idx"/>
    </div>
  </div>
</template>

<script>
import AzconTrainingCardSkeleton from "./AzconTrainingCardSkeleton.vue";

export default {
  name: "AzconCatalogSkeleton",
  components: { AzconTrainingCardSkeleton },
};
</script>

<style lang="scss" scoped>
@mixin shimmer {
  background: linear-gradient(90deg, #dce3eb 25%, #d0d8e2 50%, #dce3eb 75%);
  background-size: 200% 100%;
  animation: azcon-shimmer 1.5s infinite;
}

.azcon-catalog-skeleton {
  &__tabs {
    display: flex;
    gap: 24px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1.5px solid rgba(0, 0, 0, 0.06);
  }

  &__tab {
    width: 90px;
    height: 16px;
    border-radius: 4px;
    @include shimmer;

    &--active {
      width: 70px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -10.5px;
        height: 2px;
        border-radius: 1px;
        @include shimmer;
      }
    }
  }

  &__chips {
    display: flex;
    gap: 6px;
    margin-bottom: 14px;
  }

  &__chip {
    width: 80px;
    height: 32px;
    border-radius: 9px;
    @include shimmer;

    &:nth-child(2) { width: 100px; }
    &:nth-child(3) { width: 70px; }
    &:nth-child(4) { width: 90px; }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
}

@keyframes azcon-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (min-width: 1024px) {
  .azcon-catalog-skeleton__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
